import { useState } from "react";
import { MenuButton } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { modules } from "byzantine";
import PreviewCard from "../../PreviewCard/PreviewCard";
import DeleteTemplateDialog from "./DeleteTemplateDialog";

type TemplateCardProps = {
  templateId: API.SwiftWireTemplateId;
  onEdit: () => void;
  hasManagePermission: boolean;
};

const TemplateCard = ({
  templateId,
  onEdit,
  hasManagePermission,
}: TemplateCardProps) => {
  const { l10n } = useLocalization();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const details =
    modules.internationalWires.useSwiftWireTemplateDetails(templateId);
  if (!details) {
    return null;
  }
  const { bankDetails, title: name, subheader: recipientName } = details;

  return (
    <>
      <PreviewCard
        header={name}
        subHeader={recipientName}
        iconName="narmi-icon-bank"
        iconContent={bankDetails.rows.join(" - ")}
        actionButton={
          hasManagePermission ? (
            <MenuButton label={l10n.getString("aria-label-template-menu")}>
              <MenuButton.Item
                label={l10n.getString("button-edit-template")}
                startIcon="edit-2"
                onSelect={onEdit}
              />
              <MenuButton.Item
                label={l10n.getString("button-delete-template")}
                startIcon="trash-2"
                onSelect={() => setIsDeleteDialogOpen(true)}
              />
            </MenuButton>
          ) : undefined
        }
      />

      <DeleteTemplateDialog
        templateId={templateId}
        templateName={name}
        isOpen={isDeleteDialogOpen}
        onDismiss={() => setIsDeleteDialogOpen(false)}
      />
    </>
  );
};

export default TemplateCard;
